module.exports = __webpack_public_path__ + "d0e9d598a52812d5e98b3b09c4e8e148.svg";